import React, { useState } from "react";
import emailjs from "emailjs-com";
import HeaderInner from "../header/HeaderInner";
import Contact from "../inner/breadcrumb/Contact";
import Footer from "../elements/Footer";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
 

function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
    recaptchaToken:""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleCaptchaChange = (token) => {
    setFormData((prevData) => ({ ...prevData, recaptchaToken: token }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!formData.name || !formData.email || !formData.phone || !formData.message || !formData.subject) {
      toast.error("All fields are required");
      return;
    }

    if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      toast.error("Invalid email format");
      return;
    }

    if (!/^\d{10}$/.test(formData.phone)) {
      toast.error("Invalid phone number. Enter a 10-digit number.");
      return;
    }
    if (!formData.recaptchaToken) {
      toast.error("Please complete the reCAPTCHA");
      return;
    }

    try {
      const response = await fetch("https://v2vbn.org//contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.status === "success") {
        toast.success("Message sent successfully!");
        setFormData({ 
          name: "",
          phone: "",
          email: "",
          subject: "",
          message: "", });
      } else {
        toast.error(result.message || "Failed to send message.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="service-details contact-page">
      <div className="">
        {/* <HeaderInner/> */}
        <main>
          <Contact />
          {/* tmp contact area */}
          <div className="contact-area tmp-section-gap">
            <div className="container">
              <div className="row g-5">
                <div className="col-lg-5">
                  <div className="contact-inner">
                    <div className="section-head section-head-one-side text-align-left">
                      <span className="title">Contact Us</span>
                      <p className="description">
                        Stay connected and receive updates about events,
                        spiritual discourses, and more:
                      </p>
                    </div>
                    <ul className="ft-link ft-link-style-three">
                      <li>
                        <div className="single-contact background-transparent">
                          <div className="icon">
                            <i className="fa-light fa-phone" />
                          </div>
                          <div className="content">
                            <span>Call Us</span>
                            <a className="contact-here" href="tel:+919322687878">
                              MINESH AMRUTLAL PATEL +91 93226 87878
                              {/* <br/>       +91 96241 19580  */}
                            </a>

                            <a className="contact-here" href="tel:+919375627103">
                              <br /> Ritesh Upadhyay +91 93756 27103
                            </a>

                            <a className="contact-here" href="tel:+919924869699">
                              <br /> Jimmy Shah +91 99248 69699
                            </a>
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="single-contact background-transparent">
                          <div className="icon">
                            <i className="fa-solid fa-envelope-open-text" />
                          </div>
                          <div className="content">
                            <span>E-mail</span>
                            <a
                              className="contact-here"
                              href="mailto:admin@v2vbn.org"
                            >
                            Contact: admin@v2vbn.org
                            </a> <br />
                            <a
                              className="contact-here"
                              href="mailto:webmaster@v2vbn.org"
                            >
                            Support: webmaster@v2vbn.org 
                            </a>                            
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="single-contact background-transparent">
                          <div className="icon">
                            <i className="fa-regular fa-map-location-dot" />
                          </div>
                          <div className="content">
                            <span>Address</span>
                            <a className="contact-here" href="#">
                              Anandnagar Road, Satellite, Vrajdham Marg, Near
                              Shyamal Char Rasta, Jodhpur Village, Ahmedabad,
                              Gujarat 380015
                            </a>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div className="tmp-tag-list tag-list-one">
                      <Link className="tag-list" href="https://www.instagram.com/yadunathjimahoday/?hl=en" target="_blank">
                      <i
                          className="fa-brands fa-facebook-f"
                          style={{
                            paddingRight: "10px",
                          }}
                        />{" "}
                        Facebook
                      </Link>
                      
                      
                      <Link className="tag-list" href="https://www.facebook.com/100044332572954/photos/1182103149944093/?_rdr" target="_blank">
                      <i
                          className="fa-brands fa-instagram"
                          style={{
                            paddingRight: "10px",
                          }}
                        />
                        Instagram
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-7">
                  <div className="contact-inner">
                    <div className="section-head section-head-one-side text-align-left">
                      <span className="title">GET IN TOUCH</span>
                      <p className="description">
                        We are here to connect and serve the Vaishnav community.
                        Whether you have inquiries about our services, need
                        spiritual guidance, or wish to collaborate, feel free to
                        reach out to us.
                      </p>
                    </div>
                    <div className="contact-form style-two">
                      <div id="form-messages" />
                      <ToastContainer position="top-right" autoClose={3000} />
                      <form id="contact-form" onSubmit={handleSubmit}>
                        <div className="contact-form-wrapper row">
                          <div className="col-lg-6">
                            <div className="form-group">
                              <input
                                className="input-field"
                                name="name"
                                placeholder="Name"
                                id="contact-name"
                                type="text"
                                value={formData.name}
                                onChange={handleChange}
                                
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <input
                                className="input-field"
                                name="phone"
                                placeholder="Phone"
                                type="text"
                                value={formData.phone}
                                onChange={handleChange}
                               
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <input
                                className="input-field"
                                name="email"
                                placeholder="Email"
                                type="email"
                                value={formData.email}
                                onChange={handleChange}
                                
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <input
                                className="input-field"
                                name="subject"
                                placeholder="Subject"
                                type="text"
                                value={formData.subject}
                                onChange={handleChange}
                                
                              />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <textarea
                                className="input-field"
                                name="message"
                                placeholder="How can we help"
                                value={formData.message}
                                onChange={handleChange}
                                
                                id="contact-message"
                              />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                            <ReCAPTCHA sitekey="6LdrYwArAAAAAM5aFOMcSP_4LAemFefZ1IbGJ3Nk" onChange={handleCaptchaChange} />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-submit-group">
                              <button
                                className="tmp-btn btn-primary"
                                type="submit"
                              >
                                Submit Now
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* tmp contact area */}
          <div className="tmp-map-area tmp-sectiongapBottom">
            <div className="map-area-flotimg-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3672.2528672913227!2d72.51651907430148!3d23.01448591663186!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e9b2b3dc1cdb1%3A0x7df568cd83e60899!2sVrajdham%20Temple!5e0!3m2!1sen!2sin!4v1737175073353!5m2!1sen!2sin"
                height={500}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="map"

              ></iframe>
              
            </div>
          </div>
          {/* <Footer/> */}
        </main>
      </div>
    </div>
  );
}

export default ContactPage;
